const IMAGE_BASE_URL = 'https://faas-sgp1-18bc02ac.doserverless.co/api/v1/web/fn-eabd0529-e853-4bfe-85de-7e0fb90bd150/resource';

class ImageAPI {
  async uploadImage(imageFile) {
    try {
      // Step 1: Get pre-signed URL
      const fileName = imageFile.name;
      const mimeType = imageFile.type || 'application/octet-stream';

      const preSignedResponse = await fetch(`${IMAGE_BASE_URL}/generatePreSignedUrl`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          files: [
            {
              fileName: fileName,
              mimeType: mimeType
            }
          ]
        }),
      });

      if (!preSignedResponse.ok) {
        const errorText = await preSignedResponse.text();
        throw new Error(`Failed to get pre-signed URL: ${preSignedResponse.status} - ${errorText}`);
      }

      const preSignedData = await preSignedResponse.json();
      
      const urls = preSignedData.urls || preSignedData.body?.urls;
      if (!urls || !urls[0]) {
        throw new Error('Invalid response format from pre-signed URL endpoint');
      }
      
      const { uploadURL, publicURL } = urls[0];

      // Step 2: Upload the actual file with proper headers
      const uploadResponse = await fetch(uploadURL, {
        method: 'PUT',
        headers: {
          'Content-Type': mimeType,           // ✅ Required!
          'x-amz-acl': 'public-read',        // ✅ Makes file publicly accessible
        },
        body: imageFile,
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        throw new Error(`Failed to upload image: ${uploadResponse.status} - ${errorText}`);
      }

      // Return the public URL (strip query parameters for cleaner URL)
      const cleanPublicURL = publicURL.split('?')[0];
      
      return {
        url: cleanPublicURL,
        imageUrl: cleanPublicURL,
        image_url: cleanPublicURL
      };
    } catch (error) {
      console.error('Image upload failed:', error);
      throw error;
    }
  }
}

export default new ImageAPI();